import { supabase } from '../config/supabase';
import { NewHire } from './hireService';

export const getTeamMemberHires = async (teamMemberEmail: string): Promise<NewHire[]> => {
  console.log('Fetching hires for team member:', teamMemberEmail);
  
  // First, get the current user
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    console.error('Error getting current user:', authError);
    throw new Error('User not authenticated');
  }

  // Get the current user's profile to retrieve their org_id and role
  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('org_id, role')
    .eq('id', user.id)
    .single();

  if (profileError || !profile) {
    console.error('Error fetching user profile:', profileError);
    throw new Error('Could not fetch user profile');
  }

  // Check if user is owner
  if (profile.role !== 'owner') {
    console.error('Access denied: User is not an owner');
    throw new Error('Access denied: Only owner users can view team member hires');
  }

  // Fetch new hires filtered by team member email in recruiter_emails column
  let query = supabase
    .from('new_hire')
    .select('*')
    .eq('org_id', profile.org_id);

  // Add the ILIKE constraint to filter by team member email in recruiter_emails
  query = query.ilike('recruiter_emails', `%${teamMemberEmail}%`);

  const { data, error } = await query.order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching team member hires:', error);
    throw error;
  }

  // Convert progress to number for each hire
  const processedData = data?.map(hire => ({
    ...hire,
    progress: Number(hire.progress)
  })) || [];

  console.log('Fetched hires for team member:', teamMemberEmail, 'Data:', processedData);
  return processedData;
};

export const getOwnerMemberHires = async (ownerMemberEmail: string): Promise<NewHire[]> => {
  console.log('Fetching hires for owner member:', ownerMemberEmail);
  
  // First, get the current user
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    console.error('Error getting current user:', authError);
    throw new Error('User not authenticated');
  }

  // Get the current user's profile to retrieve their org_id and role
  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('org_id, role')
    .eq('id', user.id)
    .single();

  if (profileError || !profile) {
    console.error('Error fetching user profile:', profileError);
    throw new Error('Could not fetch user profile');
  }

  // Check if user is owner
  if (profile.role !== 'owner') {
    console.error('Access denied: User is not an owner');
    throw new Error('Access denied: Only owner users can view owner member hires');
  }

  // Fetch new hires filtered by owner member email in recruiter_emails column
  let query = supabase
    .from('new_hire')
    .select('*')
    .eq('org_id', profile.org_id);

  // Add the ILIKE constraint to filter by owner member email in recruiter_emails
  query = query.ilike('recruiter_emails', `%${ownerMemberEmail}%`);

  const { data, error } = await query.order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching owner member hires:', error);
    throw error;
  }

  // Convert progress to number for each hire
  const processedData = data?.map(hire => ({
    ...hire,
    progress: Number(hire.progress)
  })) || [];

  console.log('Fetched hires for owner member:', ownerMemberEmail, 'Data:', processedData);
  return processedData;
}; 